// Available Backlogs Page - Lists all available backlogs

import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Spinner, MessageBar, MessageBarType, useTheme, List } from '@fluentui/react';
import { useBacklog } from '../BacklogContext';
import type { Backlog } from '../types';

const AvailableBacklogsPage: React.FC = () => {
  const theme = useTheme();
  const { backlogs, loading, error, fetchBacklogs } = useBacklog();

  useEffect(() => {
    fetchBacklogs();
  }, [fetchBacklogs]);

  const onRenderCell = (item?: Backlog): JSX.Element => {
    if (!item) return <></>;

    return (
      <div
        style={{
          padding: '16px',
          marginBottom: '8px',
          backgroundColor: theme.palette.white,
          border: `1px solid ${theme.palette.neutralLight}`,
          borderRadius: '4px',
          boxShadow: theme.effects.elevation4,
        }}
      >
        <Link
          to={`/backlog/${item.id}`}
          style={{
            color: theme.palette.themePrimary,
            textDecoration: 'none',
            fontSize: '16px',
            fontWeight: '600',
          }}
        >
          {item.title}
        </Link>
      </div>
    );
  };

  if (loading) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <Spinner label="Loading backlogs..." />
      </div>
    );
  }

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <h1 style={{ color: theme.palette.neutralPrimary, marginBottom: '20px' }}>
        Available Backlogs
      </h1>

      {error && (
        <MessageBar
          messageBarType={MessageBarType.error}
          onDismiss={() => {}}
          dismissButtonAriaLabel="Close"
          style={{ marginBottom: '20px' }}
        >
          {error}
        </MessageBar>
      )}

      {backlogs.length > 0 ? (
        <List items={backlogs} onRenderCell={onRenderCell} />
      ) : (
        <div
          style={{
            textAlign: 'center',
            padding: '40px',
            color: theme.palette.neutralSecondary,
          }}
        >
          No backlogs available.
        </div>
      )}
    </div>
  );
};

export default AvailableBacklogsPage;
